import LinkRouter from '../../../../../../common/components/presentation/linkRouter/LinkRouter';
import React, { FunctionComponent } from 'react';
import { ROUTES } from '../../../../../../common/constants/routes';
import Translation from '../../../../../../common/components/translation/Translation';

const ChangeModel: FunctionComponent = () => (
  <LinkRouter
    align={'left'}
    display={'block'}
    color={'secondary'}
    underline={'always'}
    variant={'caption'}
    to={ROUTES.MODELS}
    data-test={'link:change_model'}
  >
    <Translation id={'spc.customise.changeModel'} />
  </LinkRouter>
);

export default ChangeModel;
